import React from 'react'
import Library from '../component/Library/Library'

export default function PageLibrary() {
  return (
    <div>
        <Library />
    </div>
  )
}
